/**
 * Eaglesoft Familiar wording. OWNER: the Eaglesoft Familiar agent.
 *
 * From the theme spec section 3.10 and NOTES-eaglesoft.md section 3 (exact
 * labels as read off Eaglesoft screens and Patterson KB pages). Only the
 * words that differ from Velora are listed. Keys Eaglesoft needs that the
 * shared list lacks are requested in docs/themes/requests-eaglesoft.md.
 *
 * Notes on choices:
 * - The patient record is the "Edit Person" form. "Patient Information" is
 *   Eaglesoft's own name for it (KB title, the Patient Information panel),
 *   so the patients module reads that; the toolbar button is "Person".
 * - There is no "Patient Here" status in Eaglesoft: Arrived / In Chair /
 *   Walked Out (and Late) are the arrival-dot words.
 * - "TX Plan" is spelled in capitals on the main toolbar.
 */
import type { TermMap } from '../terms.js';

export const terms: TermMap = {
  /* Modules */
  schedule: 'OnSchedule',
  familyFile: 'Patient Information',
  patientFile: 'Edit Person',
  ledger: 'Account',
  chart: 'Chart',
  perio: 'Perio',
  txPlan: 'TX Plan',
  imaging: 'Advanced Imaging',
  recall: 'Recall Wizard',
  clinicalNotes: 'Clinical Notes',
  progressNotes: 'Note History',
  checkout: 'Walkout',
  reports: 'Reports',
  communications: 'Messenger',
  documents: 'SmartDoc',
  contactLog: 'InContact',
  /* People and records */
  patient: 'Patient',
  patients: 'People',
  selectPatient: 'Person List',
  guarantor: 'Responsible Party',
  headOfHouse: 'Resp. Party',
  household: 'Family Members',
  chartNumber: 'Chart ID',
  patientId: 'ID',
  provider: 'Provider',
  operatory: 'Chair',
  newPatient: 'New Person',
  alerts: 'Patient Alerts',
  /* Scheduling */
  appointment: 'Appointment',
  pinboard: 'Appointment Queue',
  unscheduledList: 'Unscheduled Appointments',
  asapList: 'Quick Fill List',
  breakAppointment: 'Delete This Appointment',
  setComplete: 'Mark As Walked Out',
  routeSlip: 'Route Sheets',
  dayNote: 'Schedule Notes',
  huddle: 'Snapshot',
  statusArrived: 'Arrived',
  statusSeated: 'In Chair',
  statusCheckout: 'Walked Out',
  /* Money */
  payment: 'Acct Pymt',
  insurancePayment: 'Ins Pymt',
  adjustment: 'Adjustment',
  writeoff: 'Credit Adj',
  statement: 'Statement',
  claim: 'Claims',
  paymentPlan: 'Payment Plans',
  estInsurance: 'Est Ins',
  estPatient: 'Patient Portion',
  daySheet: 'Day Sheet',
  /* Clinical */
  procedureButtons: 'Quick Picks',
  procedureCodes: 'Service Codes',
  txStatusPlanned: 'Proposed',
  txStatusComplete: 'Completed',
  txStatusExisting: 'Existing',
  txStatusExistingOther: 'Existing',
  /* Shell menus: File · Activities · Lists · Reports · Online · Utilities · Window · Help */
  menuFile: '&File',
  menuEdit: '&Edit',
  menuView: '&View',
  menuModules: '&Activities',
  menuTools: '&Utilities',
  menuHelp: '&Help',
  menuVelora: 'V&elora',
};
